import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import firebase from "./firebase";
import "./App.scss";
import {
  Stack,
  TextField,
  Divider,
} from "@mui/material";
import {
  MobileDatePicker,
  LocalizationProvider,
  TimePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import Logo from "./assets/RVL-logo-black-text-white-bg.png";

function App() {
  const [data, setData] = useState([]);
  const [width, setwidth] = useState(window?.innerWidth)
  const [state, setState] = useState({
    name: "",
    email: "",
    // subject: "",
    phone: "",
    dob: "",
    comment: "No Comment",
    message: "",
    date: "",
    time: new Date(0, 0, 0, 10),
    tima30: "",
  });

  const { name, email,/* subject,*/ message, date, dob, time, phone, tima30 } =
    state;
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email /*|| !subject*/) {
      toast.error("Please Provide Value in Each Input Fields");
    } else {
      const db = firebase.firestore();
      let tima300 = moment(time).add(20, "minutes").format("HH:mm");
      setState({ ...state, tima30: tima300 });
      db.collection("/Clients").add({ state });
      setState({
        name: "",
        comment: "No comment",
        email: "",
        phone: "",
        // subject: "",
        dob: "",
        message: "",
        date: "",
        tima30: "",
        time: "",
      });
      toast.success("Form Submitted Successfully");
    }
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  return (
    <section className="contact-section">
      <div className="container">
        <ToastContainer position="top-center" />

        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="wrapper" style={{ textAlign: "center" }}>
              <img src={Logo} width="100%"></img>
              <div className="row no-gutters">
                <div className="col-md-6">
                  <div className="contact-wrap w-100 p-lg-5 p-4">
                    <h3
                      style={{
                        borderRadius: 10,
                        border: "solid 2px #d11c22",
                        borderColor: "#d11c22",
                        color: "black",
                      }}
                      className="mb-4"
                    >
                      Book a session
                    </h3>
                    <form
                      id="contactForm"
                      className="contactForm"
                      onSubmit={(e) => handleSubmit(e)}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              placeholder="Full name"
                              onChange={handleInputChange}
                              value={name}
                              style={{
                                color: "black",
                                backgroundColor: "black",
                                borderRadius: 10,
                                marginBottom: 15,
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              type="email"
                              className="form-control"
                              name="email"
                              placeholder="Email"
                              onChange={handleInputChange}
                              value={email}
                              style={{
                                backgroundColor: "black",
                                borderRadius: 10,
                                marginBottom: 15,
                              }}
                            />
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                type="tel"
                                className="form-control"
                                name="phone"
                                placeholder="Phone number"
                                onChange={handleInputChange}
                                value={phone}
                                style={{
                                  backgroundColor: "black",
                                  borderRadius: 10,
                                  marginBottom: 15,
                                }}
                              />
                            </div>
                          </div>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack
                              sx={{
                                width: "100%",
                                backgroundColor: "transparent",
                                color: "black",
                              }}
                            >
                              <MobileDatePicker
                                borderColor="black"
                                label="Date of birth"
                                inputFormat="dd/MM/yyyy"
                                required={false}
                                disableFuture
                                closeOnSelect
                                name="dob"
                                value={dob}
                                onChange={(e) => setState({ ...state, dob: e })}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                                style={{ borderRadius: 10 }}
                              />
                              <Divider sx={{ marginTop: "2%" }} />

                              <MobileDatePicker
                                borderColor="black"
                                label="Pick a date"
                                inputFormat="dd/MM/yyyy"
                                name="date"
                                disablePast
                                value={date}
                                closeOnSelect
                                onChange={(e) =>
                                  setState({ ...state, date: e })
                                }
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                                style={{ borderRadius: 10 }}
                              />
                              <Divider sx={{ marginTop: "2%" }} />
                              {width > 800 ?
                                <TimePicker
                                  style={{ borderRadius: 10 }}
                                  label="Pick a time"
                                  value={time}
                                  closeOnSelect
                                  name="time"
                                  minTime={new Date(0, 0, 0, 10)}
                                  maxTime={new Date(0, 0, 0, 20, 0)}
                                  onChange={(e) => {
                                    setState({ ...state, time: e });
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                /> :
                                <MobileTimePicker
                                  style={{ borderRadius: 10 }}
                                  label="Pick a time"
                                  value={time}
                                  closeOnSelect
                                  name="time"
                                  minTime={new Date(0, 0, 0, 10)}
                                  maxTime={new Date(0, 0, 0, 20, 0)}
                                  onChange={(e) => {
                                    setState({ ...state, time: e });
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                />
                              }
                            </Stack>
                          </LocalizationProvider>
                          <div className="col-md-12">
                            <div
                              className="form-group"
                              style={{
                                backgroundColor: "black",
                                borderRadius: 10,
                              }}
                            >
                              <textarea
                                type="text"
                                className="form-control"
                                name="message"
                                placeholder=" * Please state medical conditions if any"
                                cols="30"
                                rows="6"
                                onChange={handleInputChange}
                                value={message}
                                style={{ color: "white", fontWeight: "bolder" }}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                type="submit"
                                value="Submit"
                                className="btn"
                                style={{
                                  backgroundColor: "#d11c22",
                                  color: "white",
                                  fontWeight: "bolder",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-md-6 d-flex align-items-stretch">
                  <div className="info-wrap w-100 p-lg-5 p-4 img">
                    <h3
                      style={{
                        borderRadius: 10,
                        border: "solid 4px #d11c22",
                        borderColor: "#d11c22",
                      }}
                    >
                      Contact us
                    </h3>
                    <p className="mb-4">
                      We're Open for Any Suggestions or Just To Have a Chat
                    </p>
                    <div className="dbox w-100 d-flex align-items-start">
                      <div className="icon d-flex align-items-center justify-content-center">
                        <span
                          className="fa fa-map-marker"
                          style={{ color: "#d11c22" }}
                        ></span>
                      </div>
                      <div className="text pl-3">
                        <p>
                          <span>Address : </span>
                          <a rel="noreferrer" href="https://goo.gl/maps/H86inKgP7iwvM4NH8" target="_blank">Zouk Moshbeh, Jeita Highway</a>
                        </p>
                      </div>
                    </div>
                    <div className="dbox w-100 d-flex align-items-center">
                      <div className="icon d-flex align-items-center justify-content-center">
                        <span
                          className="fa fa-phone"
                          style={{ color: "#d11c22" }}
                        ></span>
                      </div>
                      <div className="text pl-3">
                        <p>
                          <span>Phone : </span>
                          <a href="tel://+96170653708" >+961 - 70 653 708</a>
                        </p>
                      </div>
                    </div>
                    <div className="dbox w-100 d-flex align-items-center">
                      <div className="icon d-flex align-items-center justify-content-center">
                        <span
                          className="fa fa-paper-plane"
                          style={{ color: "#d11c22" }}
                        ></span>
                      </div>
                      <div className="text pl-3">
                        <p>
                          <span>Email : </span>
                          <a rel="noreferrer" target="_blank" href="mailto:rvl.inquiries@gmail.com" >
                            rvl.inquiries@gmail.com
                          </a>
                        </p>
                      </div>
                    </div>
                    {/* <div className="dbox w-100 d-flex align-items-center">
                      <div className="icon d-flex align-items-center justify-content-center">
                        <span className="fa fa-globe"></span>
                      </div>
                      <div className="text pl-3">
                        <p>
                          <span>Website:</span>
                          <a href="#">yoursite.com</a>
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default App;
